import * as React from 'react'
import * as Sentry from '@sentry/react'
import { connect } from 'react-redux'

import { ErrorBoundary } from 'ui/multi-product/components/ErrorBoundary'
import { defaultTags } from 'common/services/Sentry'
import Tracker from 'common/services/Tracker'

import { leadInitialized } from 'common/actions'

export interface OwnProps {
  afterInit?: (trackingUuid?: string) => void
  name: string
}

export interface DispatchProps {
  dispatchLeadInitialized: (leadUuid: string) => void
}

type UiProps = OwnProps & DispatchProps

export const Ui: React.FC<UiProps> = ({ afterInit, children, dispatchLeadInitialized, name }) => {
  React.useEffect(() => {
    Tracker.init(name, dispatchLeadInitialized)
    if (afterInit) {
      Tracker.getTrackingUuid()
        .then((trackingUuid: string) => {
          afterInit?.(trackingUuid)
        })
        .catch(() => afterInit?.())
    }
  }, [])

  return (
    <Sentry.ErrorBoundary
      fallback={ErrorBoundary}
      beforeCapture={(scope) => {
        scope.setTags({
          commit: defaultTags.commit,
          ui: name,
        })
      }}
    >
      {children}
    </Sentry.ErrorBoundary>
  )
}

const mapStateToProps = (_, ownProps: OwnProps) => ownProps

const mapDispatchToProps = (dispatch) => ({
  dispatchLeadInitialized: (leadUuid: string) => dispatch(leadInitialized({ uuid: leadUuid })),
})

export default connect(mapStateToProps, mapDispatchToProps)(Ui)
